import { useRef, useEffect } from 'react';

// returns the last value that is not identical to the current value
export const useLastValue = <TValue>(value: TValue) => {
  const lastValue = useRef<TValue>();
  const currentValue = useRef<TValue>();

  useEffect(() => {
    lastValue.current = currentValue.current;
    currentValue.current = value;
  }, [value]);

  return lastValue.current;
};
